import { useTheme } from "@reactive-resume/hooks";
import { cn } from "@reactive-resume/utils";

type Props = {
  size?: number;
  className?: string;
  width?: number;
  height?: number;
};

export const Logo = ({ size, className, width, height }: Props) => {
  const { isDarkMode } = useTheme();

  let src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

  switch (isDarkMode) {
    case false: {
      src = "https://scale.jobs/branding/scale-jobs-logo.svg";
      break;
    }
    case true: {
      src = "https://scale.jobs/branding/scale-jobs-logo.svg";
      break;
    }
  }

  return (
    <img
      src={src}
      width={width || size}
      height={height || size}
      alt="scale.jobs logo"
      className={cn("rounded-sm", className)}
    />
  );
};
